import React from "react";
import { Grid, Typography, CircularProgress } from "@material-ui/core";
import { useQuery } from "@tanstack/react-query";
import AccordionPodium from "./AccordionPodium";
import { fetchEventoProva } from "../hooks/fetchEventoProva";

export default function ResultadosSection({ idEvento, etapas }) {
  const { data, isLoading, isError } = useQuery({
    queryKey: ["eventoProva", idEvento],
    queryFn: () => fetchEventoProva({ idEvento }),
    enabled: !!idEvento,
  });

  if (isLoading) {
    return (
      <Grid container justifyContent="center" style={{ padding: 40 }}>
        <CircularProgress />
      </Grid>
    );
  }

  if (isError) {
    return (
      <Grid container justifyContent="center" style={{ padding: 20 }}>
        <Typography>Erro ao carregar resultados</Typography>
      </Grid>
    );
  }

  const provasComClassificacao = (data?.provas || []).filter(
    (item) => item.classificacao && item.classificacao.length > 0
  );

  if (provasComClassificacao.length === 0) {
    return (
      <Grid container justifyContent="center" style={{ padding: 20 }}>
        <Typography>Nenhum resultado disponível</Typography>
      </Grid>
    );
  }

  return (
    <Grid container spacing={2}>
      {provasComClassificacao.map((item, key) => (
        <Grid item xs={12} key={key}>
          <AccordionPodium etapas={etapas} eventoProva={item} />
        </Grid>
      ))}
    </Grid>
  );
}
